// extracted by mini-css-extract-plugin
module.exports = {"time":"OpeningTime-module--time--2yIuX","label":"OpeningTime-module--label--1kESf","closed":"OpeningTime-module--closed--1MwpM","next":"OpeningTime-module--next--1GecV"};